// Locales available in the application or CV export
import "moment/dist/locale/fr-ca";
import "moment/dist/locale/fr";
import "moment/dist/locale/da";
import "moment/dist/locale/sv";
import "moment/dist/locale/fi";
import "moment/dist/locale/nb";
import "moment/dist/locale/ja";
import "moment/dist/locale/pt";
import "moment/dist/locale/es";
import "moment/dist/locale/de";

import toLower from "lodash/toLower";
import moment from "moment";
import { DEFAULT_LOCALE } from "PFCore/helpers/date";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { LanguageResourceKey } from "PFCore/i18n/resources";
import { useEffect } from "react";
import { useMount } from "react-use";

const MONDAY = 1; // Monday is the first day of the week.

const momentLocaleMap = {
  [LanguageResourceKey.frCA]: "fr-ca",
  [LanguageResourceKey.frFR]: "fr",
  [LanguageResourceKey.esES]: "es",
  [LanguageResourceKey.noNO]: "nb",
  [LanguageResourceKey.ptPT]: "pt",
  [LanguageResourceKey.svSE]: "sv",
  [LanguageResourceKey.deDE]: "de",
  [LanguageResourceKey.fiFI]: "fi",
  [LanguageResourceKey.daDK]: "da",
  [LanguageResourceKey.jaJP]: "ja"
};

export const updateMomentLocale = (localeCode: string = DEFAULT_LOCALE) => {
  const locale = momentLocaleMap[localeCode] || toLower(localeCode);
  moment.updateLocale(locale, {
    week: {
      dow: MONDAY
    }
  });
  moment.locale(locale);
};

export const useMomentLocale = () => {
  useMount(() => updateMomentLocale());
};

export const useMomentLocaleForCurrentProfile = () => {
  const { data: currentProfile } = useCurrentProfile();
  const locale = currentProfile?.locale;

  useEffect(() => {
    if (!locale) {
      return;
    }
    updateMomentLocale(locale);
  }, [locale]);
};
